export const downloadBlobResponse = (response, fallbackFileName) => {
  const blob = response?.data;
  if (!blob) return;

  const disposition = response?.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i);
  const fileName = decodeURIComponent(match?.[1] || match?.[2] || fallbackFileName);

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const printBlobResponse = (response) => {
  const blob = response?.data;
  if (!blob) return;

  const url = window.URL.createObjectURL(blob);
  const win = window.open(url, "_blank", "noopener,noreferrer");

  if (win) {
    win.addEventListener("load", () => {
      win.focus();
      win.print();
    });
  }
};

export const exportCsv = (fileName, rows = []) => {
  if (!rows.length) return;

  const headers = Object.keys(rows[0]);
  const escapeValue = (value) => {
    const safe = value === null || value === undefined ? "" : String(value);
    return `"${safe.replace(/"/g, '""')}"`;
  };
  const csv = [
    headers.join(","),
    ...rows.map((row) => headers.map((header) => escapeValue(row[header])).join(",")),
  ].join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
